module.exports = __webpack_public_path__ + "img/top.460f0b0d.png";